// Libs
import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClientProvider } from 'react-query';
import { persistQueryClient } from 'react-query/persistQueryClient-experimental';
import { createAsyncStoragePersistor } from 'react-query/createAsyncStoragePersistor-experimental';

// Components
import App from './app';
import Compose from './components/compose/compose';

// Contexts
import { LifeCycleProvider } from './contexts/life-cycle.context';
import { ControllsProvider } from './contexts/controlls.context';
import { StatsProvider } from './contexts/stats.context';
import { NavigationProvider } from './contexts/navigation.context';
import { ErrorBoundaryProvider } from './contexts/error-boundary.context';

// Config
import { queryClient } from './config/query-client';

import './styles/index.scss';

//storage
import storage from './modules/storage';
import { QueryCacheStorageAdapter } from './adapters/query-cache.adapter';

const asyncStoragePersistor = createAsyncStoragePersistor({
	key: 'queryCache',
	throttleTime: 0,
	serialize: data => data as any,
	deserialize: data => data as any,
	storage: new QueryCacheStorageAdapter(storage)
});

(async () => {
	try {
		await persistQueryClient({
			queryClient,
			persistor: asyncStoragePersistor
		});
	} catch {}
	ReactDOM.render(
		<React.StrictMode>
			<Compose
				components={[
					[QueryClientProvider, { client: queryClient }],
					LifeCycleProvider,
					ControllsProvider,
					StatsProvider,
					NavigationProvider,
					ErrorBoundaryProvider
				]}
			>
				<App />
			</Compose>
		</React.StrictMode>,
		document.getElementById('root')
	);
})();
